const SIGNALR_CONNECT = "@signalr/SIGNALR_CONNECT";
const SIGNALR_DISCONNECT = "@signalr/SIGNALR_DISCONNECT";

export {
  SIGNALR_CONNECT,
  SIGNALR_DISCONNECT
};
